import http from "../http";
import { CustomAxiosError } from "../../helpers/customErrors";

export default {
  // Whose address this is, and who (if anyone) is signed in at it.
  async sessionApi() {
    try {
      const response = await http().get("auth/session");
      return response.data;
    } catch (error) {
      throw new CustomAxiosError(error.response?.data || error.message);
    }
  },

  async adminLoginApi(data) {
    try {
      const response = await http().post("admin/auth/login", data);
      return response.data;
    } catch (error) {
      throw new CustomAxiosError(error.response?.data || error.message);
    }
  },

  async tenantLoginApi(data) {
    try {
      const response = await http().post("tenant/auth/login", data);
      return response.data;
    } catch (error) {
      throw new CustomAxiosError(error.response?.data || error.message);
    }
  },

  async adminProfileApi() {
    try {
      const response = await http().get("admin/auth/profile");
      return response.data;
    } catch (error) {
      throw new CustomAxiosError(error.response?.data || error.message);
    }
  },

  async tenantProfileApi() {
    try {
      const response = await http().get("tenant/auth/profile");
      return response.data;
    } catch (error) {
      throw new CustomAxiosError(error.response?.data || error.message);
    }
  },

  async adminLogoutApi() {
    try {
      const response = await http().post("admin/auth/logout");
      return response.data;
    } catch (error) {
      throw new CustomAxiosError(error.response?.data || error.message);
    }
  },

  async tenantLogoutApi() {
    try {
      const response = await http().post("tenant/auth/logout");
      return response.data;
    } catch (error) {
      throw new CustomAxiosError(error.response?.data || error.message);
    }
  },

  async acceptInviteApi(data) {
    try {
      const response = await http().post("tenant/invite/accept", data);
      return response.data;
    } catch (error) {
      throw new CustomAxiosError(error.response?.data || error.message);
    }
  },
  async adminAcceptInviteApi(data) {
    try {
      const response = await http().post("admin/invite/accept", data);
      return response.data;
    } catch (error) {
      throw new CustomAxiosError(error.response?.data || error.message);
    }
  },
  async adminHeartbeatApi() {
    try {
      const response = await http().get("admin/auth/heartbeat");
      return response.data;
    } catch (error) {
      throw new CustomAxiosError(error.response?.data || error.message);
    }
  },

  async tenantHeartbeatApi() {
    try {
      const response = await http().get("tenant/auth/heartbeat");
      return response.data;
    } catch (error) {
      throw new CustomAxiosError(error.response?.data || error.message);
    }
  },

  /*
   * The second step of a sign-in (P0.10). Login may answer with a challenge
   * instead of a session: a code from the authenticator app, enrolling one
   * first, or a new password. Each carries the challenge token back.
   */
  async mfaChallengeApi(data) {
    try {
      const response = await http().post("tenant/auth/mfa/challenge", data);
      return response.data;
    } catch (error) {
      throw new CustomAxiosError(error.response?.data || error.message);
    }
  },

  async mfaChallengeEnrolApi(data) {
    try {
      const response = await http().post("tenant/auth/mfa/challenge/enrol", data);
      return response.data;
    } catch (error) {
      throw new CustomAxiosError(error.response?.data || error.message);
    }
  },

  async renewPasswordApi(data) {
    try {
      const response = await http().post("tenant/auth/password/renew", data);
      return response.data;
    } catch (error) {
      throw new CustomAxiosError(error.response?.data || error.message);
    }
  },

  async passwordPolicyApi() {
    try {
      const response = await http().get("tenant/auth/password-policy");
      return response.data;
    } catch (error) {
      throw new CustomAxiosError(error.response?.data || error.message);
    }
  },

  // Signed in: your own two-step sign-in.
  async mfaStatusApi() {
    try {
      const response = await http().get("tenant/auth/mfa");
      return response.data;
    } catch (error) {
      throw new CustomAxiosError(error.response?.data || error.message);
    }
  },

  async mfaEnrolApi() {
    try {
      const response = await http().post("tenant/auth/mfa/enrol");
      return response.data;
    } catch (error) {
      throw new CustomAxiosError(error.response?.data || error.message);
    }
  },

  async mfaConfirmApi(data) {
    try {
      const response = await http().post("tenant/auth/mfa/confirm", data);
      return response.data;
    } catch (error) {
      throw new CustomAxiosError(error.response?.data || error.message);
    }
  },

  async mfaDisableApi(data) {
    try {
      const response = await http().post("tenant/auth/mfa/disable", data);
      return response.data;
    } catch (error) {
      throw new CustomAxiosError(error.response?.data || error.message);
    }
  },

  async mfaRecoveryCodesApi(data) {
    try {
      const response = await http().post("tenant/auth/mfa/recovery-codes", data);
      return response.data;
    } catch (error) {
      throw new CustomAxiosError(error.response?.data || error.message);
    }
  },

  async changePasswordApi(data) {
    try {
      const response = await http().put("tenant/auth/password", data);
      return response.data;
    } catch (error) {
      throw new CustomAxiosError(error.response?.data || error.message);
    }
  },

  /*
   * Forgotten passwords: a reset link by email, then a new password. `scope`
   * is the session's ("admin" on the admin console, "tenant" in a company).
   */
  async forgotPasswordApi(scope, data) {
    try {
      const response = await http().post(`${scope === "admin" ? "admin" : "tenant"}/auth/password/forgot`, data);
      return response.data;
    } catch (error) {
      throw new CustomAxiosError(error.response?.data || error.message);
    }
  },

  async checkResetLinkApi(scope, data) {
    try {
      const response = await http().post(`${scope === "admin" ? "admin" : "tenant"}/auth/password/reset/check`, data);
      return response.data;
    } catch (error) {
      throw new CustomAxiosError(error.response?.data || error.message);
    }
  },

  async resetPasswordApi(scope, data) {
    try {
      const response = await http().post(`${scope === "admin" ? "admin" : "tenant"}/auth/password/reset`, data);
      return response.data;
    } catch (error) {
      throw new CustomAxiosError(error.response?.data || error.message);
    }
  },
};
